// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2PexZ","footer":"ModalError_footer__9nzJc"};